module.exports = __webpack_public_path__ + "assets/img/news (34).5a87bdbc.png";